"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXAmendProvision = exports.HTMLAmendProvision = exports.HTMLAmendProvisionCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const columnsOrSentencesRun_1 = require("./columnsOrSentencesRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const any_1 = require("./any");
const common_1 = require("../common");
exports.HTMLAmendProvisionCSS = `
.amend-provision-main {    
    text-indent: 1em;
}
`;
exports.HTMLAmendProvision = (0, html_1.wrapHTMLComponent)("HTMLAmendProvision", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    for (const child of el.children) {
        if (std.isAmendProvisionSentence(child)) {
            blocks.push((react_1.default.createElement("div", { className: `amend-provision-main indent-${indent}` },
                react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: child.children, htmlOptions }))));
        }
        else if (std.isNewProvision(child)) {
            blocks.push((react_1.default.createElement("div", { className: "new-provision", ...(0, html_1.elProps)(child, htmlOptions) },
                react_1.default.createElement(any_1.HTMLAnyELs, { els: child.children, indent: indent + 1, htmlOptions }))));
        }
        else {
            throw (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement("div", { className: "amend-provision", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXAmendProvision = (0, component_1.wrapDOCXComponent)("DOCXAmendProvision", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    for (const child of el.children) {
        if (std.isAmendProvisionSentence(child)) {
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(tags_1.w.pPr, null,
                    react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
                react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: child.children, docxOptions }))));
        }
        else if (std.isNewProvision(child)) {
            blocks.push(react_1.default.createElement(any_1.DOCXAnyELs, { els: child.children, indent: indent + 1, docxOptions }));
        }
        else {
            throw (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=amendProvision.js.map